import {
  PartialProduct, shouldShowStartingAt,
  minimumPriceInCurrencyForFlavourControlAndNewPriceZero,
} from "types/Product";
import {
  Typography,
  CircularProgress
} from "@mui/material";
import { Colors } from "helpers/Consts";

type Props = {
  product: PartialProduct | undefined
}

function PriceTag({ product }: Props) {
  if(!product) return (
    <>
      <CircularProgress />
  </>)

  // se não deve mostrar "A partir de:", então
  // vai mostrar o preço e também, caso o new_price for menor que old_price,
  // mostra então preço antigo com 'riscado' para reforçar
  if(!shouldShowStartingAt(product)) {
    return(
      <>
        <Typography
          variant="body2"
          color="green"
          style={{
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          {product?.new_price.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}
        </Typography>
        {product.old_price > product.new_price && (
          <Typography
            variant="body2"
            color={Colors.grayTextColorDark}
            style={{
              fontWeight: 700,
              fontSize: "20px",
              marginLeft: "5px",
              textDecoration: "line-through",
            }}
          >
            {product?.old_price.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </Typography>)}
      </>
    )
  } // FIM do IF não-mostrar-preço-a-partir-de

  // agora, se for item com sabores e também com preço igual a zero,
  // então vamos mostrar apenas o seguinte texto:
  // A PARTIR DE: R$ (menor preço da lista de sabores)
  return(
    <>
      <Typography
        variant="body2"
        color={Colors.grayTextColorDark}
        style={{
          fontWeight: 400,
          fontSize: "14px",
          verticalAlign: "middle",
          marginBottom: "auto",
          marginTop: "auto",
        }}
      >
        a partir de:
      </Typography>
      <Typography
        variant="body2"
        color="green"
        style={{
          marginLeft: "7px",
          fontWeight: 700,
          fontSize: "20px",
        }}
      >
        {minimumPriceInCurrencyForFlavourControlAndNewPriceZero(product)}
      </Typography>
    </>
  )
}

export default PriceTag